import { useTimezone } from '@app/core/hooks/useTimezone';
import { DateField, TimeField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import { useFormikContext } from 'formik';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { GipReportValues } from '../types';
import {
  combineDateWithExistingTime,
  combineTimeWithExistingDate,
  formatTimeInputValue,
} from './apply-gip-report-datetime';

export const ToField = () => {
  const { $t } = useIntl();
  const {
    values: { to },
    setFieldValue,
  } = useFormikContext<GipReportValues>();
  const tz = useTimezone();

  return (
    <Grid container>
      <Grid item xs={12} md={7}>
        <DateField
          name="to"
          label={$t({
            id: 'audit.gipReport.form.endDate',
            defaultMessage: 'Fecha de fin',
          })}
          max={moment(new Date()).format('YYYY-MM-DD')}
          isOutsideRange={(date) => moment(date) > moment()}
          onChange={(value) => {
            const next = combineDateWithExistingTime(to, value, tz);
            if (next !== null) {
              setFieldValue('to', next);
            }
          }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TimeField
          name="to_time"
          label={$t({
            id: 'audit.gipReport.form.endTime',
            defaultMessage: 'Hora de fin',
          })}
          value={formatTimeInputValue(to)}
          onChange={(event) => {
            const next = combineTimeWithExistingDate(to, event.currentTarget.value);
            if (next !== null) {
              setFieldValue('to', next);
            }
          }}
        />
      </Grid>
    </Grid>
  );
};
